import "./Banner.styles.css";
const Banner = () => {
    return (
      <div className="banner">
        <h2 className="text">Our Booking System is Now Online!</h2>
        <p className="subText">We sincerely apologize for the recent inconvenience and appreciate your patience. Thank you for understanding!</p>
      </div>
    );
  };

export default Banner;
